import { css } from '@emotion/react';

const badgeStyles = {
    free: css({
        background: '#3CBC00',
        alignItems: 'center',
        fontStyle: 'normal',
        textTransform: 'uppercase',
        padding: '5px 8px',
        fontSize: '12px',
        fontWeight: 800,
        color: '#ffffff',
        display: 'inline',
        borderRadius: '3px',
        width: 'fit-content',
        marginLeft: '2px',
    }),
    freeConnector: css({
        background: '#3CBC0026',
        alignItems: 'center',
        fontStyle: 'normal',
        textTransform: 'uppercase',
        padding: '5px 8px',
        fontSize: '12px',
        fontWeight: 800,
        color: '#3CBC00',
        display: 'inline',
        borderRadius: '3px',
        width: 'fit-content',
        marginLeft: '2px',
    }),
};

export default badgeStyles;
